import { render, staticRenderFns } from "./_transferModal.vue?vue&type=template&id=2e899f4c"
import script from "./_transferModal.vue?vue&type=script&lang=js"
export * from "./_transferModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports